import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useBrandFeatureCheck } from '@/brand';
import { trpc } from '@/trpc/client';

const FALLBACK_PATH = '/account/contact';

/**
 * Redirects the user away if the user management feature is unavailable.
 * TODO: Not ideal that this is on the client - we should handle this on the server-side.
 */
export const useBookingManagementFeatureBlock = () => {
  const { push } = useRouter();
  const enabledInBrandConfig = useBrandFeatureCheck('bookingManagement');
  // TODO: Prefetch this
  const flags = trpc.flags.activeExperiments.useQuery();
  const flagEnabled = flags.data?.['booking-management'];

  useEffect(() => {
    if (!enabledInBrandConfig) {
      push(FALLBACK_PATH);
    }

    if (flags.isFetched && !flagEnabled) {
      push(FALLBACK_PATH);
    }
  }, [enabledInBrandConfig, push, flags.isFetched, flagEnabled]);
};
